<template>
  <v-app>
    <!-- <v-row v-if="!isMobile" no-gutters align="center" justify="center" class="hot-news-container">
      <v-col cols="1">
        <v-img max-width="70%" class="hot-news-img" eager src="https://storage.googleapis.com/mwm-website-v2-content/home/french_tech.png" />
      </v-col>
      <v-col cols="4">
        <span class="hot-news-text" @click="openFt120" v-html="hotNewsText"></span>
      </v-col>
    </v-row>
    <v-row v-else no-gutters align="center" justify="space-around" class="hot-news-container">
      <v-col cols="2">
        <v-img class="hot-news-img" eager src="https://storage.googleapis.com/mwm-website-v2-content/home/french_tech.png" />
      </v-col>
      <v-col cols="9">
        <span class="hot-news-text" @click="openFt120" v-html="hotNewsText"></span>
      </v-col>
    </v-row> -->

    <v-app-bar clipped-left dense app color="black">
      <v-app-bar-nav-icon dark @click.stop="navDrawerStatus = !navDrawerStatus" v-if="isMobile"></v-app-bar-nav-icon>

      <v-spacer v-if="isMobile" />
      <v-toolbar-title>
        <router-link :to="'/'">
          <v-img v-if="isMobile" class="header-logo" eager src="https://storage.googleapis.com/mwm-website-v2-content/logo-mwm.svg" />
          <v-img v-else eager src="/static/img/mwm_logo_small.png" />
        </router-link>
      </v-toolbar-title>
      <v-spacer v-if="isMobile" />

      <v-tabs v-if="!isMobile && shouldShowTabs" right dark v-model="tab">
        <v-tab class="topbar-item" v-for="link in topLinks" :key="link.name" :ripple="false" :to="link.link">
          {{ link.title }}<span :class="link.link === tab ? 'topbar-dot' : 'topbar-dot topbar-hidden'">.</span>
        </v-tab>
      </v-tabs>
    </v-app-bar>

    <v-navigation-drawer v-model="navDrawerStatus" width="70%" color="black" app clipped v-if="isMobile">
      <div v-for="link in topLinks" :key="link.name">
        <v-row no-gutters align="center" justify="space-between">
          <v-col cols="2">
            <img width="80" class="mt-3" src="https://storage.googleapis.com/mwm-website-v2-content/navdrawer-list-icon.svg">
          </v-col>
          <v-col cols="8">
            <router-link :to="link.link" class="footer-link">
              <span class="drawer-item-text">{{ link.title }}</span>
            </router-link>
          </v-col>
        </v-row>
      </div>
      <div v-for="link in bottomLinks" :key="link.name">
        <v-row v-if="link.name !== 'covid' || (link.name === 'covid' && isCovid)" no-gutters align="center" justify="space-between">
          <v-col cols="2">
            <img width="80" class="mt-3" src="https://storage.googleapis.com/mwm-website-v2-content/navdrawer-list-icon.svg">
          </v-col>
          <v-col cols="8">
            <router-link :to="link.link" class="footer-link">
              <span class="drawer-item-text">{{ link.title }}</span>
            </router-link>
          </v-col>
        </v-row>
      </div>
    </v-navigation-drawer>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer height="50" padless class="footer">
      <router-link v-if="!isMobile" class="ml-4" :to="'/'">
        <v-img eager src="/static/img/mwm_logo_small.png" />
      </router-link>

      <v-spacer />

      <router-link v-if="!isMobile" class="footer-link legal-notice" to="/legal-notice">
        <span class="footer-text">Legal</span>
      </router-link>
      <a v-if="!isMobile" class="footer-link legal-notice" href="https://www.musicworldmedia.com/terms-of-use">
        <span class="footer-text">Terms of Use</span>
      </a>
      <a v-if="!isMobile" class="footer-link privacy-policy " href="https://www.musicworldmedia.com/privacy-policy ">
        <span class="footer-text">Privacy Policy</span>
      </a>
      <router-link v-if="!isMobile && isCovid" class="footer-link covid" to="/covid">
        <span class="footer-text">#creezchezvous</span>
      </router-link>
      <router-link v-if="!isMobile" class="footer-link press" to="/press">
        <span class="footer-text">Press</span>
      </router-link>
      <router-link v-if="!isMobile" class="footer-link rd" to="/hardware">
        <span class="footer-text">R & D</span>
      </router-link>
      <v-img eager v-for="social in socialLinks" :key="social.key" class="footer-logo" contain height="31px" max-width="31" :src="social.src" @click="openUrl(social.link)" />
      <v-spacer v-if="isMobile" />
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';

import CssHolder from '@/mixins/CssHolder.vue';
import SizeHolder from '@/mixins/SizeHolder.vue';

const axios = require('axios');

export default {
  mixins: [CssHolder, SizeHolder],
  data: () => ({
    tab: 0,
    navDrawerStatus: null,
    shouldShowTabs: false,

    topLinks: [
      { name: 'home', title: 'Home', link: '/', color: '' },
      { name: 'apps', title: 'Apps', link: '/apps', color: '' },
      { name: 'career', title: 'Career', link: '/career', color: '' },
    ],
    bottomLinks: [
      { name: 'covid', title: '#creezchezvous', link: '/covid', color: '' },
      { name: 'hardware', title: 'R & D', link: '/hardware', color: '' },
      { name: 'press', title: 'Press', link: '/press', color: '' },
    ],
    socialLinks: [
      { key: 'linkedin', src: 'https://storage.googleapis.com/mwm-website-v2-content/social-linkedin.svg', link: 'https://www.linkedin.com/company/mwmcompany/' },
      { key: 'fb', src: 'https://storage.googleapis.com/mwm-website-v2-content/social-fb.svg', link: 'https://www.facebook.com/MWMcompany/' },
      { key: 'instagram', src: 'https://storage.googleapis.com/mwm-website-v2-content/social-insta.svg', link: 'https://www.instagram.com/mwm.company/' },
      { key: 'twitter', src: 'https://storage.googleapis.com/mwm-website-v2-content/social-twitter.svg', link: 'https://twitter.com/MWMcompany/' },
    ],

    hotNewsText: '<b>HOT NEWS :</b> We are proud to announce that <b>MWM</b> is among the best french startups according to the French Tech 120 🔥'
  }),
  methods: {
    openFt120 () {
      this.openUrl('https://lafrenchtech.com/fr/la-france-aide-les-startups/french-tech-120-2/')
    },
    openUrl (url) {
      const win = window.open(url, '_blank');
      win.focus();
    },
    evaluateCovid () {
      axios.get('https://europe-west1-mwm-website.cloudfunctions.net/covid')
        .then((response) => {
          const isCovid = response.data === 'FR';
          this.$store.commit('setIsCovid', isCovid);
        });
    }
  },
  computed: {
    ...mapGetters([
      'isCovid',
    ]),
  },
  mounted () {
    setTimeout(() => {
      this.shouldShowTabs = true;
    }, 250);

    this.evaluateCovid();
  }
};
</script>

<style lang="scss">

@media (max-width: 960px) {
  .hot-news-text {
    font-size: 11px!important;
    line-height: normal!important;
  }
}

.hot-news-container {
  z-index: 1;
  position: fixed;
  top: 48px;
  width: 100%;
  background: #4E10B3;
}

.hot-news-img {
  // max-width: 64px;
  // border-radius: 50%;
}

.hot-news-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 24px;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.hot-news-text:hover {
  text-decoration: underline;
}

.v-tabs .topbar-item {
  font-family: CenturyGothic;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
}

.v-tabs .v-tabs-slider-wrapper {
  bottom: unset;
}

.v-tabs .v-tabs-slider-wrapper .v-tabs-slider {
  height: 4px;
  border-radius: 2px;
  box-shadow: 0 5px 25px 0 #ff4290;
  background-image: -webkit-gradient(linear, right top, left top, color-stop(115%, #990cb4), color-stop(12%, #ff0067));
  background-image: linear-gradient(to left, #990cb4, #ff0067);
}

.topbar-dot {
  font-size: 25px;
  padding-bottom: 6px;
  color: #fe08d1;
  opacity: 1;
  transition: opacity 0.3s linear;
}
.topbar-dot.topbar-hidden {
  opacity: 0;
}

.header-logo {
  margin-right: 2rem;
}

.footer {
  background-image: linear-gradient(to right, #10141c 2%, #212a39 99%);
  background-image: -webkit-gradient(linear, left, right, color-stop(2%, #10141c), color-stop(99%, #212a39));
}

.footer-text {
  font-family: CenturyGothic;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  color: #ffffff;
}

.footer-link {
  text-decoration: unset;
}

.legal-notice {
  margin-right: 3rem;
}

.privacy-policy  {
  margin-right: 3rem;
}

.covid {
  margin-right: 3rem;
}

.press {
  margin-right: 3rem;
}

.rd {
  margin-right: 2.3rem;
}

.footer-logo {
  margin-left: 0.7rem;
  margin-right: 0.7rem;
  cursor: pointer;
}

.drawer-item-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
</style>
